<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="stories ? stories.edges : []"
      class="elevation-1"
      :options.sync="options"
      :footer-props="{
        disablePagination: $apollo.loading,
        disableItemsPerPage: true,
      }"
      :loading="$apollo.loading"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("admin.stories.stories") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
          {{ search }}
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" :key="'edit-' + editedItem.id">
            <EditDialog
              :editedItem="editedItem"
              @dialog="dialog = $event"
              :key="editedItem.id"
              @reset="reset"
              :availableStatuses="availableStatuses"
            />
          </v-dialog>
          <v-dialog v-model="editInfoDialog" :key="'editInfo-' + editedItem.id">
            <EditInfoDialog
              :editedItem="editedItem"
              :key="editedItem.id"
              @dialog="editInfoDialog = $event"
              @reset="resetEditInfo"
            />
          </v-dialog>
          <v-dialog
            v-model="editOwnerDialog"
            :key="'editOwner-' + editedItem.id"
          >
            <EditOwnerDialog
              :editedItem="editedItem"
              :key="editedItem.id"
              @dialog="editOwnerDialog = $event"
              @reset="editOwnerDialog = false"
            />
          </v-dialog>
          <CloneDialog
            :editedItem="editedItem"
            :enableDialog="cloneDialog"
            @reset="cloneDialog = false"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.node.owner.email`]="{ item }">
        {{ item.node.owner.email }}
        <v-icon small class="mr-2" @click="editOwner(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:[`item.node.status.id`]="{ item }">
        {{ item.node.status.id }}
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItemInfo(item)">
          mdi-pencil
        </v-icon>
        <ViewStory
          :storyId="item.node.id"
          :compareDateString="reviewMode ? item.node.statusUpdatedAt : null"
        />
        <router-link
          :to="{
            name: 'basic-info',
            params: {
              id: item.node.id.substring(item.node.id.indexOf('/', 1) + 1),
            },
          }"
        >
          <v-icon small class="mr-2"> mdi-feather </v-icon>
        </router-link>
        <v-icon small class="mr-2" @click="clone(item)">
          mdi-content-copy
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import gql from "graphql-tag";
import iris from "@/iris";
import { STORY_STATUS } from "@/const";
import EditDialog from "./EditDialog";
import EditInfoDialog from "./EditInfoDialog";
import EditOwnerDialog from "./EditOwnerDialog";
import CloneDialog from "./CloneDialog";
import ViewStory from "./ViewStory";
export default {
  components: {
    CloneDialog,
    EditDialog,
    EditInfoDialog,
    EditOwnerDialog,
    ViewStory,
  },
  data() {
    return {
      editedItem: {},
      editInfoDialog: false,
      editOwnerDialog: false,
      cloneDialog: false,
      dialog: false,
      options: { itemsPerPage: 1000 },
      after: null,
      before: null,
      totalItems: 0,
      search: "",
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("admin.id"), value: "node.id" },
        { text: this.$t("story.title"), value: "node.name" },
        { text: this.$t("admin.ownerEmail"), value: "node.owner.email" },
        {
          text: this.$t("admin.ownerUsername"),
          value: "node.owner.userProfile.username",
        },
        {
          text: this.$t("storyHub.publishing.publishedStatus"),
          value: "node.status.id",
        },
        {
          text: this.$t("admin.stories.statusUpdatedAt"),
          value: "node.statusUpdatedAt",
        },
        { text: this.$t("admin.actions"), value: "actions" },
      ];
    },
    reviewMode() {
      return this.$router.currentRoute.name == "admin-review-stories";
    },
  },
  apollo: {
    stories: {
      query: gql`
        query GetStories($first: Int, $after: String, $before: String) {
          stories(first: $first, after: $after, before: $before) {
            edges {
              node {
                id
                name
                owner {
                  id
                  email
                  userProfile {
                    id
                    username
                  }
                }
                status {
                  id
                }
                statusUpdatedAt
                updatedAt
                chapters {
                  id
                  updatedAt
                }
              }
            }
            pageInfo {
              endCursor
              startCursor
              hasNextPage
              hasPreviousPage
            }
            totalCount
          }
        }
      `,
      variables() {
        return {
          first: this.options.itemsPerPage,
          after: this.after,
          before: this.before,
        };
      },
      update(data) {
        if (!this.reviewMode) {
          return data.stories;
        } else {
          let stories = { edges: [] };
          for (const edge of data.stories.edges) {
            let addStory = false;
            const story = edge.node;
            if (story.status.id != iris.status + STORY_STATUS.Draft) {
              const statusUpdatedDate = new Date(story.statusUpdatedAt);
              const storyUpdatedAt = new Date(story.updatedAt);
              if (
                story.status.id ==
                iris.status + encodeURI(STORY_STATUS.InReview)
              ) {
                addStory = true;
              } else if (
                storyUpdatedAt.getTime() > statusUpdatedDate.getTime()
              ) {
                addStory = true;
              } else {
                for (const chapter of edge.node.chapters) {
                  const chapterUpdatedAt = new Date(chapter.updatedAt);
                  if (
                    chapterUpdatedAt.getTime() > statusUpdatedDate.getTime()
                  ) {
                    addStory = true;
                  }
                }
              }
            }
            if (addStory) {
              stories.edges.push(edge);
            }
          }
          return stories;
        }
      },
    },
    availableStatuses: {
      query: gql`
        query {
          storyStatuses {
            id
          }
        }
      `,
      update(data) {
        return data.storyStatuses.map((status) => status.id);
      },
    },
  },
  methods: {
    editItem(item) {
      this.editedItem = { ...item.node };
      this.dialog = true;
    },
    editItemInfo(item) {
      this.editedItem = { ...item.node };
      this.editInfoDialog = true;
    },
    editOwner(item) {
      this.editedItem = { ...item.node };
      this.editOwnerDialog = true;
    },
    reset() {
      this.dialog = false;
      this.editedItem = {};
    },
    resetEditInfo() {
      this.editInfoDialog = false;
      this.editedItem = {};
    },
    clone(item) {
      this.editedItem = { ...item.node };
      this.cloneDialog = true;
    },
  },
  // TODO this is some real round-peg square-hole shit right here
  // TODO we're using cursor based pagination but we're using
  // TODO it in paged based pagination here
  // TODO needs to be fixed at some point, but its quite functional for now
  // TODO need to figure out if API platform can handle two separate
  // TODO pagination types on one object
  watch: {
    options: {
      handler(newValue, oldValue) {
        if (newValue.page == 1) {
          this.after = null;
          this.before = null;
        } else if (newValue.page > oldValue.page) {
          this.after = this.stories.pageInfo.endCursor;
          this.before = null;
        } else if (newValue.page < oldValue.page) {
          this.after = null;
          this.before = this.stories.pageInfo.startCursor;
        }
      },
      deep: true,
    },
  },
};
</script>